import i18next from 'i18next';
import moment from 'moment';
import { isCNP as validateCnp, isCIF as validateCif } from '@totalsoft/validations';
import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input/mobile';
import { emptyString } from 'constants/emptyConst';

export const noValidation = () => {
  return {
    msg: null,
    func: () => true
  };
};

export const isEmail = () => {
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)+)|([^<>()[\]\\.,;:\s@"]{2,})|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]{2,}\.)+[a-zA-Z]{2,}))$/;
  return {
    msg: i18next.t('Validations.Generic.Email'),
    func: value => !value || re.test(String(value).toLowerCase())
  };
};

export const validateCompanyUniqueId = countryCode => {
  return {
    msg: i18next.t('Validations.Generic.RegistrationCode'),
    func: unique_id => {
      return isCompanyUniqueId(unique_id, countryCode);
    }
  };
};

export const validatePersonUniqueId = countryCode => {
  return {
    msg: i18next.t('Validations.Generic.CNP'),
    func: unique_id => {
      return isPersonUniqueId(unique_id, countryCode);
    }
  };
};

export const multipleEmailsValid = () => {
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let isValid = true;

  return {
    msg: i18next.t('Validations.Generic.MultipleEmails'),
    func: arrayString => {
      const values = arrayString.split(';');
      isValid = values.every(value => (!value && value !== emptyString) || re.test(String(value).toLowerCase()));
      return isValid;
    }
  };
};

export const isMobilePhone = () => {
  var re = /^(07[0-9]{1}[0-9]{1}){1}?(\s|\.)?([0-9]{3}(\s|\.|)){2}$/;
  return {
    msg: i18next.t('Validations.Generic.Phone'),
    func: value => !value || re.test(String(value))
  };
};

export const isPhone = () => {
  var re = /^(0[2|3|7]{1}[0-9]{1}[0-9]{1}){1}?(\s|\.)?([0-9]{3}(\s|\.|)){2}$/;
  return {
    msg: i18next.t('Validations.Generic.Phone'),
    func: value => !value || re.test(String(value))
  };
};

export const testMobilePhone = (phone, countryCode) => {
  let phoneNumber = parsePhoneNumber(phone, countryCode);
  return isValidPhoneNumber(phoneNumber ? phoneNumber.number : phone);
};

export const phone = countryCode => {
  return {
    msg: i18next.t('Validations.Generic.Phone'),
    func: value => !value || testMobilePhone(value, countryCode)
  };
};

export const noSpaceAtBeginning = () => {
  var input = /^[\S0-9a-zA-Z]/;
  return {
    msg: i18next.t('Validations.Generic.NoSpace'),
    func: value => {
      return !value || input.test(String(value));
    }
  };
};

export const checkForDuplicateUniqueId = clientUniqueId => {
  return {
    msg: i18next.t('Validations.AssociatedPartner.DuplicateUniqueId'),
    func: value => !(value === clientUniqueId)
  };
};

export const isSeriesAndNumber = countryCode => {
  return {
    msg: i18next.t('Validations.Client.SeriesAndNumber'),
    func: value => !value || validateSeriesAndNumber(String(value), countryCode)
  };
};

export const validateSeriesAndNumber = (value, countryCode) => {
  if (countryCode === 'RO') return isRomanianSeriesAndNumber(value);
  if (countryCode === 'BG') return isBulgarianSeriesAndNumber(value);
};

export const isRomanianSeriesAndNumber = function isRomanianSeriesAndNumber(x) {
  const input = /^[A-Za-z]{2}\d{6,7}$/;
  return input.test(String(x));
};

export const isBulgarianSeriesAndNumber = function isBulgarianSeriesAndNumber(x) {
  const input = /^\d{9}$/;
  return input.test(String(x));
};

export const isCIF = () => {
  return {
    msg: i18next.t('Validations.Generic.RegistrationCode'),
    func: cif => {
      validateCif(cif);
    }
  };
};

export const isCnp = () => {
  return {
    msg: i18next.t('Validations.Generic.CNP'),
    func: p_cnp => validateCnp(p_cnp)
  };
};

export const isCompanyUniqueId = (uniqueId, countryCode) => {
  switch (countryCode) {
    case 'RO':
      return validateCif(uniqueId);
    case 'BG':
      return isUIC(uniqueId);
    default:
      return true;
  }
};


var isUIC = function isUIC(uic) {
  if (!uic) return false;
  const re = /^BG\d{9}$/;

  return re.test(uic);
};

export const isPersonUniqueId = (uniqueId, countryCode) => {
  switch (countryCode) {
    case 'RO':
      return isCNP(uniqueId);
    case 'BG':
      return isEGN(uniqueId);
    default:
      return true;
  }
};

var isCNP = function isCNP(p_cnp) {
  if (!p_cnp) return true;
  p_cnp = p_cnp.trim();

  if (p_cnp.length !== 13) {
    return false;
  }

  if (isNaN(Number(p_cnp)) || parseInt(p_cnp, 10) !== Number(p_cnp)) {
    return false;
  }

  var i = 0,
    year = 0,
    month = 0,
    day = 0,
    hashResult = 0,
    cnp = [],
    hashTable = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];

  for (i = 0; i < 13; i++) {
    cnp[i] = parseInt(p_cnp[i], 10);

    if (i < 12) {
      hashResult = hashResult + cnp[i] * hashTable[i];
    }
  }

  hashResult = hashResult % 11;

  if (hashResult === 10) {
    hashResult = 1;
  }

  year = cnp[1] * 10 + cnp[2];
  month = cnp[3] * 10 + cnp[4];
  day = cnp[5] * 10 + cnp[6];

  switch (cnp[0]) {
    case 1:
    case 2:
      year += 1900;
      break;

    case 3:
    case 4:
      year += 1800;
      break;

    case 5:
    case 6:
      year += 2000;
      break;

    case 7:
    case 8:
    case 9:
      year += 2000;

      if (year > new Date().getFullYear() - 18) {
        year -= 100;
      }

      break;

    default: {
      return false;
    }
  }

  if (year < 1800 || year > 2099) {
    return false;
  }

  if (!(0, moment)(''.concat(year, '-').concat(month, '-').concat(day)).isValid()) {
    return false;
  }

  return cnp[12] === hashResult;
};

var isEGN = function isEGN(p_egn) {
  if (!p_egn) return true;
  p_egn = p_egn.trim();

  if (p_egn.length !== 10) {
    return false;
  }

  if (isNaN(Number(p_egn)) || parseInt(p_egn, 10) !== Number(p_egn)) {
    return false;
  }

  var year = 0,
    month = 0,
    day = 0,
    hashResult = 0,
    egn = [],
    hashTable = [2, 4, 8, 5, 10, 9, 7, 3, 6];

  for (var i = 0; i < 10; i++) {
    egn[i] = parseInt(p_egn[i], 10);

    if (i < 9) {
      hashResult += egn[i] * hashTable[i];
    }
  }

  hashResult = hashResult % 11;
  if (hashResult === 10) {
    hashResult = 0;
  }

  year = egn[0] * 10 + egn[1];
  month = egn[2] * 10 + egn[3];
  day = egn[4] * 10 + egn[5];

  if (month >= 1 && month <= 12) {
    year += 1900;
  } else if (month >= 21 && month <= 32) {
    month -= 20;
    year += 1800;
  } else if (month >= 41 && month <= 52) {
    month -= 40;
    year += 2000;
  } else {
    return false;
  }

  if (year < 1800 || year > 2099) {
    return false;
  }

  var date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
    return false;
  }
  return egn[9] === hashResult;
};

export const validateCompanyOrPersonUniqueId = (countryCode) => {
  return {
    msg: i18next.t('Validations.Generic.CnpOrRegistrationCode'),
    func: unique_id => {
      return validateCompanyUniqueId(unique_id, countryCode) || validatePersonUniqueId(unique_id, countryCode);
    }
  };
};

export const isInInterval = interval => {
  return {
    msg: i18next.t('Validations.Generic.ValidityDaysForIdentityCard', { validityDays: interval }),
    func: validUntilDate => {
      const currentDate = new Date().getTime();
      var milisecondsInterval = (interval - 1) * 86400000;

      if (new Date(validUntilDate) > new Date(currentDate + milisecondsInterval)) return true;
      else return false;
    }
  };
};

export const isBirthDateAccordingToUniqueId = (p_cnp, countryCode) => {
  return {
    msg: i18next.t('Validations.Generic.BirthDate'),
    func: birthDate => checkBirthDateAccordingToUniqueId(p_cnp, birthDate, countryCode)
  };
};

export const checkBirthDateAccordingToUniqueId = (uniqueId, birthDate, countryCode) => {
  if (!uniqueId) return true;
  if (!birthDate) return false;
  let date;
  switch (countryCode) {
    case 'RO':
      date = extractBirthDateFromCnp(uniqueId);
      break;
    case 'BG':
      date = extractBirthDateFromEGN(uniqueId);
      break;
    default:
      return false;
  }
  if (!date || !birthDate) return false;
  date.setHours(0, 0, 0, 0);

  const actualBirthDate = new Date(Date.parse(birthDate));
  actualBirthDate.setHours(0, 0, 0, 0);
  if (date.valueOf() !== actualBirthDate.valueOf()) return false;
  return true;
};

export const extractBirthDateFromUniqueId = (uniqueId, countryCode) => {
  let uniqueIdDate;
  switch (countryCode) {
    case 'RO':
      uniqueIdDate = extractBirthDateFromCnp(uniqueId);
      break;
    case 'BG':
      uniqueIdDate = extractBirthDateFromEGN(uniqueId);
      break;
    default:
      return new Date();
  }
  return uniqueIdDate;
};

export const extractBirthDateFromCnp = cnp => {
  if (!cnp) return null;
  if (!isCnp(cnp)) return null;

  const sexChar = cnp.substring(0, 1);
  const yearSuffix = cnp.substring(1, 3);
  const month = cnp.substring(3, 5);
  const day = cnp.substring(5, 7);
  let yearOfBirth = null;

  if (sexChar === '1' || sexChar === '2') yearOfBirth = '19' + yearSuffix;
  if (sexChar === '5' || sexChar === '6') yearOfBirth = '20' + yearSuffix;
  if (sexChar === '3' || sexChar === '4') yearOfBirth = '18' + yearSuffix;
  if (sexChar === '7' || sexChar === '8') {
    let currentYearSuffix = new Date().getFullYear() % 100;
    let yearPrefix = yearSuffix <= currentYearSuffix ? '20' : '19';
    yearOfBirth = yearPrefix + yearSuffix;
  }
  if (yearOfBirth) return new Date(yearOfBirth, month - 1, day);
  return null;
};
export const extractBirthDateFromEGN = egn => {
  if (!egn) return null;

  const yearSuffix = egn.substring(0, 2);
  const month = egn.substring(2, 4);
  const day = egn.substring(4, 6);
  var yearOfBirth = null;

  const currentYear = new Date().getFullYear() % 100;
  if (parseInt(yearSuffix) > currentYear) {
    yearOfBirth = '19' + yearSuffix;
  } else {
    yearOfBirth = '20' + yearSuffix;
  }
  if (yearOfBirth) return new Date(yearOfBirth, month - 1, day);
  return true;
};

export const isChassisNumber = () => {
  return {
    msg: i18next.t('Validations.Generic.ChassisNumber'),
    func: chassisNumber => {
      if (!chassisNumber) return true;

      if (chassisNumber.length !== 17) return false;

      for (var i = 0; i < chassisNumber.length; i++) {
        if (
          !(chassisNumber.charCodeAt(i) >= 48 && chassisNumber.charCodeAt(i) <= 57) &&
          !(chassisNumber.charCodeAt(i) >= 65 && chassisNumber.charCodeAt(i) <= 122)
        )
          return false;
      }

      return true;
    }
  };
};

export const isMandatory = () => {
  return {
    msg: i18next.t('Validations.Generic.Mandatory'),
    func: value => value !== null && value !== undefined && value !== ''
  };
};

export const isValidDateFormat = () => {
  const allowedDateFormats = ['DD/MM/YYYY', 'DD.MM.YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'];
  return {
    msg: i18next.t('Validations.Generic.InvalidDateFormat'),
    func: value =>
      !value ||
      (moment(value, allowedDateFormats).isValid() && moment(value, allowedDateFormats).isAfter(moment('01.01.1900', allowedDateFormats)))
  };
};

export const isValidRocketUIDateFormat = () => {
  return {
    msg: i18next.t('Validations.Generic.InvalidDateFormat'),
    func: value => {
      return !value || (Date.parse(value) && new Date(value) > new Date('01/01/1900'));
    }
  };
};

export const hasFile = file => {
  return {
    msg: i18next.t('Validations.Generic.NoFile'),
    func: value => {
      return !value || (value && file !== null && file !== undefined);
    }
  };
};

export const isInRange = (min, max) => {
  // const minString = typeof min === "function" ? "" : min;
  // const maxString = typeof max === "function" ? "" : max;
  // const string = " (" + minString + " - " + maxString + ")";
  // TODO: make it right

  const adjustNumber = value => +Number(value)?.toFixed(2);

  return {
    msg: i18next.t('Validations.Generic.OutOfRange'),
    func: (value, document) => {
      const adjustedValue = adjustNumber(value);
      const left = typeof min === 'function' ? adjustNumber(min(document)) : adjustNumber(min);
      const right = typeof max === 'function' ? adjustNumber(max(document)) : adjustNumber(max);
      return (!adjustedValue && adjustedValue !== 0) || (adjustedValue >= left && adjustedValue <= right);
    }
  };
};

export const isDerivedInRange = (map, min, max) => {
  return {
    msg: i18next.t('Validations.Generic.OutOfRange'),
    func: (value, document) => {
      const left = typeof min === 'function' ? min(document) : min;
      const right = typeof max === 'function' ? max(document) : max;
      const derivedValue = map(value);
      return (!derivedValue && derivedValue !== 0) || (derivedValue >= left && derivedValue <= right);
    }
  };
};

export const isGreaterThan = min => {
  return {
    msg: i18next.t('Validations.Generic.OutOfRange'),
    func: (value, document) => {
      const left = typeof min === 'function' ? min(document) : min;
      return value > left;
    }
  };
};

export const isPositive = () => {
  return {
    msg: i18next.t('Validations.Generic.Positive'),
    func: function verifyIfPositive(value) {
      return Number.isFinite(value) && value >= 0;
    }
  };
};

export const dateIsGreaterThan = min => {
  return {
    msg: i18next.t('Validations.Generic.OutOfRange'),
    func: (value, document) => {
      const left = typeof min === 'function' ? min(document) : min;
      return left ? moment(value).isSameOrAfter(moment(left)) : true;
    }
  };
};

export const isLessThan = max => {
  return {
    msg: i18next.t('Validations.Generic.OutOfRange'),
    func: (value, document) => {
      const left = typeof max === 'function' ? max(document) : max;
      return value < left;
    }
  };
};

export const dateIsLessThan = max => {
  return {
    msg: i18next.t('Validations.Generic.OutOfRange'),
    func: (value, document) => {
      const right = typeof max === 'function' ? max(document) : max;
      return right ? moment(value).isSameOrBefore(moment(right)) : true;
    }
  };
};

export const hasLengthLessThan = max => {
  return {
    msg: i18next.t('Validations.Generic.MaxCharacters', { max: max }),
    func: (value, document) => {
      const right = typeof max === 'function' ? max(document) : max;
      return value ? value.length <= right : true;
    }
  };
};

export const foreach = itemValidationRule => (document, items) =>
  items.reduce(
    (accumulator, item, index) => ({
      ...accumulator,
      [index]: typeof itemValidationRule === 'function' ? itemValidationRule(item, document) : itemValidationRule
    }),
    {}
  );

export const foreachProp = itemValidationRule => (document, values) =>
  Object.keys(values).reduce(
    (accumulator, prop) => ({
      ...accumulator,
      [prop]: typeof itemValidationRule === 'function' ? itemValidationRule(document, values[prop]) : itemValidationRule
    }),
    {}
  );

export const isUnique = (selector, collectionFn) => {
  return {
    msg: i18next.t('Validations.Generic.Unique'),
    func: (value, document) => {
      if (!document) return true;
      const collection = collectionFn(document);
      if (!collection) return true;
      const list = collection.map(selector).filter(x => x === value);
      return [...new Set(list)].length === 0;
    }
  };
};
